"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = exports.SessionState = void 0;
var SessionState;
(function (SessionState) {
    SessionState[SessionState["Invalid"] = 0] = "Invalid";
    SessionState[SessionState["Init"] = 1] = "Init";
    SessionState[SessionState["Connecting"] = 2] = "Connecting";
    SessionState[SessionState["Connected"] = 3] = "Connected";
    SessionState[SessionState["Streaming"] = 4] = "Streaming";
    SessionState[SessionState["Disconnected"] = 5] = "Disconnected";
    SessionState[SessionState["Rated"] = 6] = "Rated";
})(SessionState = exports.SessionState || (exports.SessionState = {}));
exports.actionCreators = {
    initializeSession: function () { return function (dispatch, getState) {
        dispatch({ type: 'SESSION_INIT' });
    }; },
    requestTaskState: function (guid) { return function (dispatch, getState) {
        var appState = getState();
        if (appState) {
            fetch("/api/connection/query/" + guid)
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_TASK_STATE', sessionState: data.state });
            });
            dispatch({ type: 'REQUEST_TASK_STATE', requestGuid: guid });
        }
    }; },
    requestTaskRating: function (guid) { return function (dispatch, getState) {
        var appState = getState();
        if (appState) {
            fetch("/api/connection/query/rating/" + guid)
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                var theRate = (data.rating && data.rating[0].rating > 0) ? data.rating : undefined;
                dispatch({ type: 'RECEIVE_TASK_RATING', ratings: theRate });
            });
            dispatch({ type: 'REQUEST_TASK_RATING', requestGuid: guid });
        }
    }; },
    requestSessionStats: function (guid) { return function (dispatch, getState) {
        var appState = getState();
        if (appState) {
            fetch("/api/connection/stats/" + guid)
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                console.log(data);
                dispatch({ type: 'RECEIVE_SESSION_STATS', sessionStats: (data.sessionStats && data.sessionStats.duration > 0) ? data.sessionStats : undefined });
            });
            dispatch({ type: 'REQUEST_SESSION_STATS', requestGuid: guid });
        }
    }; },
    requestServerStats: function () { return function (dispatch, getState) {
        var appState = getState();
        if (appState) {
            fetch("/api/serverstatus/stats")
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_SERVER_STATS', serverStats: (data.sessionStats && data.sessionStats.duration > 0) ? data.sessionStats : undefined });
            });
            dispatch({ type: 'REQUEST_SERVER_STATS' });
        }
    }; },
    requestConnect: function (guid) { return function (dispatch, getState) {
        var appState = getState();
        if (appState) {
            fetch("/api/connection/connect/" + guid)
                .then(function (response) {
                if (!response.ok)
                    dispatch({ type: 'RECEIVE_DISCONNECT' });
                else {
                    var info = response.json();
                    info.then(function (data) { return dispatch({ type: 'RECEIVE_CONNECT', connectedClient: data }); });
                }
            })
                .catch(function () { return dispatch({ type: 'RECEIVE_DISCONNECT' }); });
            dispatch({ type: 'REQUEST_CONNECT', requestGuid: guid });
        }
    }; },
    requestDisconnect: function (unintentional) { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.clientList && appState.clientList.connectedClient) {
            fetch("/api/" + (unintentional ? 'drop' : 'disconnect') + "/" + appState.clientList.connectedClient.sessionGuid)
                .then(function (response) { return response.json(); })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_DISCONNECT' });
            });
            dispatch({ type: 'REQUEST_DISCONNECT', requestGuid: appState.clientList.connectedClient.sessionGuid });
        }
    }; },
    setDisconnect: function () { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.clientList) {
            dispatch({ type: 'RECEIVE_DISCONNECT' });
        }
    }; },
    requestStartStreaming: function () { return function (dispatch, getState) {
        dispatch({ type: 'START_STREAM' });
    }; }
};
var unloadedState = {
    isLoading: false, connectedClient: undefined, sessionState: SessionState.Invalid, ratings: undefined, sessionStats: undefined, serverStats: undefined
};
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_CONNECT':
            return {
                isLoading: true,
                connectedClient: unloadedState.connectedClient,
                sessionState: SessionState.Connecting,
                ratings: undefined,
                sessionStats: state.sessionStats,
                serverStats: state.serverStats
            };
        case 'RECEIVE_CONNECT':
            return {
                isLoading: false,
                connectedClient: action.connectedClient,
                sessionState: SessionState.Connected,
                ratings: undefined,
                sessionStats: state.sessionStats,
                serverStats: state.serverStats
            };
        case 'REQUEST_DISCONNECT':
            return {
                isLoading: true,
                connectedClient: state.connectedClient,
                sessionState: SessionState.Disconnected,
                ratings: undefined,
                sessionStats: state.sessionStats,
                serverStats: state.serverStats
            };
        case 'RECEIVE_DISCONNECT':
            return {
                isLoading: false,
                connectedClient: state.connectedClient,
                sessionState: SessionState.Disconnected,
                ratings: undefined,
                sessionStats: state.sessionStats,
                serverStats: state.serverStats
            };
        case 'START_STREAM':
            return {
                isLoading: state.isLoading,
                connectedClient: state.connectedClient,
                sessionState: SessionState.Streaming,
                ratings: state.ratings,
                sessionStats: state.sessionStats,
                serverStats: state.serverStats
            };
        case 'REQUEST_TASK_STATE':
            return {
                isLoading: true,
                connectedClient: state.connectedClient,
                sessionState: state.sessionState,
                ratings: state.ratings,
                sessionStats: state.sessionStats,
                serverStats: state.serverStats
            };
        case 'RECEIVE_TASK_STATE':
            return {
                isLoading: false,
                connectedClient: state.connectedClient,
                sessionState: action.sessionState,
                ratings: state.ratings,
                sessionStats: state.sessionStats,
                serverStats: state.serverStats
            };
        case 'REQUEST_TASK_RATING':
            return {
                isLoading: true,
                connectedClient: state.connectedClient,
                sessionState: state.sessionState,
                ratings: state.ratings,
                sessionStats: state.sessionStats,
                serverStats: state.serverStats
            };
        case 'RECEIVE_TASK_RATING':
            return {
                isLoading: false,
                connectedClient: state.connectedClient,
                sessionState: state.sessionState,
                ratings: action.ratings,
                sessionStats: state.sessionStats,
                serverStats: state.serverStats
            };
        case 'REQUEST_SESSION_STATS':
            return {
                isLoading: false,
                connectedClient: state.connectedClient,
                sessionState: state.sessionState,
                ratings: state.ratings,
                sessionStats: undefined,
                serverStats: state.serverStats
            };
        case 'RECEIVE_SESSION_STATS':
            return {
                isLoading: false,
                connectedClient: state.connectedClient,
                sessionState: state.sessionState,
                ratings: state.ratings,
                sessionStats: action.sessionStats,
                serverStats: state.serverStats
            };
        case 'REQUEST_SERVER_STATS':
            return {
                isLoading: false,
                connectedClient: state.connectedClient,
                sessionState: state.sessionState,
                ratings: state.ratings,
                sessionStats: state.sessionStats,
                serverStats: state.serverStats
            };
        case 'RECEIVE_SERVER_STATS':
            return {
                isLoading: false,
                connectedClient: state.connectedClient,
                sessionState: state.sessionState,
                ratings: state.ratings,
                sessionStats: state.sessionStats,
                serverStats: action.serverStats
            };
        default:
            return state;
    }
};
//# sourceMappingURL=ClientList.js.map